/**
 * The exam screen a candidate writes a paper on (/exam/:examId/take). The
 * temporary-password gate (4.2) never covers it: an attempt in progress is
 * finished first, the new password chosen after (PrivateRoute, services/api).
 */
export const isExamPaperPath = (path = "") => /^\/exam\/[^/]+\/take\/?$/.test(String(path));
